import { Component, OnInit } from '@angular/core';
import { timer } from 'rxjs';

import { SecurityService } from '../../../services/security.service';
import { Constants } from '../../../constants';

@Component({
  selector: 'com-unauthorised',
  templateUrl: './unauthorised.component.html',
  styleUrls: ['./unauthorised.component.scss']
})
export class UnauthorisedComponent implements OnInit {
  accountType: string;

  constructor(private security: SecurityService) {}

  async ngOnInit(): Promise<void> {
    const user = this.security.user;
    this.accountType = user.profile[
      Constants.claimTypes.providerType
    ] as string;
    //this.accountType = this.security.profile.selectedAccount?.providerTypeString;

    const source = timer(5000);
    const subscribe = source.subscribe({
      complete: async () => await this.security.logout(),
    });
  }
}
